// extracted by mini-css-extract-plugin
export default {"cardBubble":"HUJpi","hide":"sz4GE","closeBubble":"AQ4Lk","bubbleHeading":"Rt8SR","title":"bnosY","text":"FU44Z","icon":"Q1uJ6"};